import { constants } from '@config';

// see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
export const CANVAS_DIMENSION_LIMIT = 16384;
export const CSS_URL_REGEX = /url\((['"]?)(.*?)\1\)/g;
export const DEFAULT_OPTIONS = {
  width: null,
  height: null,
  pixelRatio: null,
  backgroundColor: null,
  embeddedFontsStyleElement: null,
  imageReplacement: 'smart', // 'smart' | 'none' | imageVersion
  imageFallbacks: [
    'thumb',
    'mobile',
    'tab',
    'web',
    'largeweb',
    'original'
  ],
  imageMaxByteSize: 1024 * 1024 * 8, // 8 MB
  quality: 0.92,
  type: 'image/png',
  willReadFrequently: false,
  cache: false
};
export const SELECTOR_BACKGROUND_COLOR = constants.background.color;
export const SELECTOR_BACKGROUND_IMAGE = constants.background.image;
